module.exports = __webpack_public_path__ + "static/media/arrow_back_ios_24px.000277f0.svg";